import { Platform, Text, View } from 'react-native';
import { detectPwaInstallPlatform, type PwaInstallPlatform } from '../platform/pwa-install';
import { styles } from '../theme';
import type { Translation } from '../types';

function stepsForPlatform(t: Translation, platform: PwaInstallPlatform) {
  if (platform === 'ios') {
    return [t.pwaInstallIos1, t.pwaInstallIos2, t.pwaInstallIos3];
  }
  if (platform === 'android') {
    return [t.pwaInstallAndroid1, t.pwaInstallAndroid2, t.pwaInstallAndroid3];
  }
  return [t.pwaInstallDesktop1, t.pwaInstallDesktop2];
}

function platformLabel(t: Translation, platform: PwaInstallPlatform) {
  if (platform === 'ios') {
    return t.pwaInstallIosLabel;
  }
  if (platform === 'android') {
    return t.pwaInstallAndroidLabel;
  }
  return t.pwaInstallDesktopLabel;
}

export function PwaInstallInstructions({ t }: { t: Translation }) {
  const platform = detectPwaInstallPlatform();
  if (Platform.OS !== 'web' || !platform) {
    return null;
  }

  const steps = stepsForPlatform(t, platform);

  return (
    <View style={styles.pwaInstallCard}>
      <Text style={styles.pwaInstallTitle}>{t.pwaInstallTitle}</Text>
      <Text style={styles.pwaInstallIntro}>{t.pwaInstallIntro}</Text>
      <Text style={styles.pwaInstallPlatform}>{platformLabel(t, platform)}</Text>
      <View style={styles.pwaInstallSteps}>
        {steps.map((step, index) => (
          <View key={step} style={styles.pwaInstallStepRow}>
            <Text style={styles.pwaInstallStepNumber}>{index + 1}</Text>
            <Text style={styles.pwaInstallStepText}>{step}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}
